import {
  EllipsisOutlined,
  CheckOutlined,
  LockOutlined,
  MinusOutlined,
  InfoOutlined,
} from '@ant-design/icons';
import { clsx } from 'clsx';

import cls from './badge.module.css';

interface Props {
  status: 'ok' | 'info' | 'pending' | 'warn' | 'error' | 'default' | 'draft'
    | 'revision' | 'denied' | 'approved';
  label?: string;
  className?: string;
}

export const Badge = ({ status = 'default', label, className }: Props) => {
  let clsIcon = cls.defaultIcon;
  let clsText = cls.defaultText;
  let Icon: any = MinusOutlined;

  switch (status) {
    case 'ok':
      clsIcon = cls.okIcon;
      clsText = cls.okText;
      Icon = CheckOutlined;
      break;
    case 'approved':
      clsIcon = cls.approvedIcon;
      clsText = cls.approvedText;
      Icon = ApprovedIcon;
      break;
    case 'info':
      clsIcon = cls.infoIcon;
      clsText = cls.infoText;
      Icon = InfoOutlined;
      break;
    case 'pending':
      clsIcon = cls.pendingIcon;
      clsText = cls.pendingText;
      Icon = InfoOutlined;
      break;
    case 'revision':
      clsIcon = cls.pendingIcon;
      clsText = cls.pendingText;
      Icon = InfoOutlined;
      break;
    case 'warn':
      clsIcon = cls.warnIcon;
      clsText = cls.warnText;
      Icon = EllipsisOutlined;
      break;
    case 'error':
      clsIcon = cls.errorIcon;
      clsText = cls.errorText;
      Icon = LockOutlined;
      break;
    case 'denied':
      clsIcon = cls.deniedIcon;
      clsText = cls.deniedText;
      Icon = DeniedIcon;
      break;
    case 'draft':
      clsIcon = cls.draftIcon;
      clsText = cls.draftText;
      Icon = InfoOutlined;
      break;
  }

  return (
    <div className={clsx(cls.box, className)}>
      <span className={clsx(cls.iconBox, clsIcon, 'badge-icon-box')}>
        <Icon className={cls.icon} />
      </span>
      <span className={clsx(cls.text, clsText, 'badge-text')}>
        {label || status}
      </span>
    </div>
  );
};

const ApprovedIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="20" height="20" rx="10" fill="#275D3C" />
    <path d="M9.28577 11.9639L13.7501 7.49952"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round" />
    <path d="M9.28577 11.9639L7.50003 10.1781"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round" />
  </svg>
);

const DeniedIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 0C4.47801 0 0 4.47801 0 10C0 15.522 4.47801 20 10 20C15.522 20 20 15.522 20 10C19.9911 4.47801 15.5175 0.00444247 10 0Z"
      fill="#FF4548" />
    <path d="M11.7132 9.80362L13.3947 11.5778C13.8684 12.0753 13.8684 12.8795 13.3947 13.3769C12.9211 13.8744 12.1553 13.8744 11.6816 13.3769L10 11.6027L8.31053 13.3686C7.84474 13.8661 7.07895 13.8661 6.60526 13.3686C6.13158 12.8712 6.13158 12.067 6.60526 11.5695L8.28684 9.80362L6.60526 8.02941C6.13158 7.54026 6.13158 6.73606 6.60526 6.23862C6.84211 5.9899 7.15 5.86554 7.45789 5.86554C7.76579 5.86554 8.07368 5.9899 8.31053 6.23862L10 8.00454L11.6895 6.23862C11.9263 5.9899 12.2342 5.86554 12.5421 5.86554C12.85 5.86554 13.1579 5.9899 13.3947 6.23862C13.8684 6.73606 13.8684 7.54026 13.3947 8.0377L11.7132 9.80362Z"
      fill="white" />
  </svg>
);
